import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const TempImage = ({ image: imageNode, alt = '' }) => {
  const {
    allFile: { edges: images },
  } = useStaticQuery(imageQuery)

  const getImageNode = (imageName) => {
    const [imageUrl] = images.filter((imageUrl) => {
      return imageUrl.node.name === imageName
    })
    return imageUrl.node
  }

  const image = getImageNode(imageNode.title)

  return <GatsbyImage objectFit="contain" alt={alt} image={getImage(image)} />
}

export default TempImage

// Temp queries all images
export const imageQuery = graphql`
  {
    allFile(filter: { sourceInstanceName: { eq: "images" } }) {
      edges {
        node {
          name
          url
          publicURL
          childImageSharp {
            gatsbyImageData(width: 960)
          }
        }
      }
    }
  }
`
